import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import {
  withStyles,
  ListItem,
  Icon,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@material-ui/core';
import styles from './styles';

export const NavItemComponent = ({
  location,
  label,
  route,
  classes,
  icon,
  expandNavSection,
  collapseNavSection,
  containedInSection,
}) => {
  const [expandNavSectionCalled, setExpandNavSectionCalled] = useState(false);

  const isCurrentPage = location.pathname.indexOf(route) > -1;
  if (isCurrentPage && !expandNavSectionCalled) {
    setExpandNavSectionCalled(true);
    expandNavSection();
  }

  return (
    <Link to={route} href={route} role="button" onClick={collapseNavSection}>
      <ListItem
        button
        className={[
          isCurrentPage
            ? classes.highlight
            : classes.listItem,
          isCurrentPage && !containedInSection
            ? classes.highlightBorder
            : {},
        ].join(' ')}
      >
        {
          icon
            && (
              <Tooltip title={label} placement="right">
                <ListItemIcon
                  className={
                    isCurrentPage
                      ? classes.listItemIconHighlight
                      : classes.listItemIcon
                  }
                >
                  <Icon>
                    {icon}
                  </Icon>
                </ListItemIcon>
              </Tooltip>
            )
        }
        <ListItemText primary={label} />
      </ListItem>
    </Link>
  );
};

NavItemComponent.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  route: PropTypes.string,
  icon: PropTypes.string,
  classes: PropTypes.object,
  expandNavSection: PropTypes.func,
  collapseNavSection: PropTypes.func,
  containedInSection: PropTypes.bool,
};

NavItemComponent.defaultProps = {
  label: '',
  route: '',
  icon: '',
  location: { pathname: '' },
  classes: { highlight: '' },
  expandNavSection: () => {},
  collapseNavSection: () => {},
  containedInSection: false,
};

export const NavItemStyled = withStyles(styles)(NavItemComponent);
export default withRouter(withStyles(styles)(NavItemComponent));
